import React from 'react';
import { useWillMount } from '@beef/react';

import { LayoutType } from '../types';

export const useYoungTariffLayout = (layoutType: LayoutType): boolean => {
  const [state, setState] = React.useState<boolean>(false);

  useWillMount(() => {
    setState(layoutType === LayoutType.Young);
  });

  return state;
};
